import {CLEAR_DIPLOMA, SET_DIPLOMA, CLEAR_HISTORICO_PARCIAL, SET_HISTORICO_PARCIAL, SET_LOADING, SET_MESSAGE} from './actionTypes';
import {MESSAGE_ERROR} from '../constants';

export const setLoading = isLoading => {
    return (dispatch, getState) => {
        const {
            embedded
        } = getState();

        if (embedded) {
            parent.postMessage(isLoading ? 'showLoading' : 'hideLoading', "*");
        } else {
            dispatch(_setLoading(isLoading));
        }
    };
};

export const _setLoading = isLoading => ({
    type: SET_LOADING,
    isLoading
});

export const sendMessage = (typeMessage, text) => ({
    type: SET_MESSAGE,
    typeMessage,
    text
});

export const setDiploma = diploma => ({
    type: SET_DIPLOMA,
    diploma
});

export const clearDiploma = () => ({
    type: CLEAR_DIPLOMA
});

export const setHistoricoParcial = historicoParcial => ({
    type: SET_HISTORICO_PARCIAL,
    historicoParcial
});

export const clearHistoricoParcial = () => ({
    type: CLEAR_HISTORICO_PARCIAL
});

export const handleError = dispatch => error => {
    const errorMessage = error.mensagem || error;

    dispatch(setLoading(false));
    dispatch(sendMessage(MESSAGE_ERROR, errorMessage));

    if (error.detalhe) {
        console.log(error.detalhe);
    } else {
        console.log(errorMessage);
    }

    return Promise.reject(errorMessage);
};